const eventTypes = [
  "AUTHORIZATION_SPECIAL_ATTACK",
  "CLIENT_EXPLICITLY_SUSPENDS_PROJECT",
  "CLONING_ISSUES",
  "CREDENTIAL_ISSUES",
  "DATA_UPDATE_REQUIRED",
  "ENVIRONMENT_ISSUES",
  "INSTALLER_ISSUES",
  "MISSING_SUPPLIES",
  "NETWORK_ACCESS_ISSUES",
  "REMOTE_ACCESS_ISSUES",
  "TOE_DIFFERS_APPROVED",
  "VPN_ISSUES",
  "OTHER",
];

export { eventTypes };
